import { createEffect, ofType, Actions } from "@ngrx/effects";
import {
  withLatestFrom,
  switchMap,
  map,
  catchError
} from "rxjs/operators";
import { Store } from "@ngrx/store";
import { DaveActions } from "../actions/actions";
import { HttpService } from "../../services/http.service";
import { State } from "../index";
import { DamageFlowTypeActionTypes } from "../actions/damageFlowType.actions";
import { DamageFlowTypeEntityFromBackend } from "../../entities/damageFlowType.entity";
import { BaseActionTypes } from "../actions/base.actions";
import { of } from "rxjs";
import { Injectable } from "@angular/core";

enum ErrorCodes {
  Load = "Schadensarten abrufen fehlgeschlagen",
  Modify = "Schadensarten bearbeiten fehlgeschlagen"
}

@Injectable()
export class DamageFlowTypeEffects {

  LoadDamageFlowTypes = createEffect(() => this.actions$.pipe(
    ofType(DamageFlowTypeActionTypes.GetDamageFlowTypeRequest),
    withLatestFrom(this.store$),
    switchMap(([action, store]) => {
      const queryString = `
      query{
        damageFlowType{
          id
          name
          partnerId
        }
      }`;
      return this.gatewayHttpService
        .graphQl({ query: queryString }, { token: store.base.token, retry: true })
        .pipe(
          map(res =>
            res && res.damageFlowType
              ? DamageFlowTypeActionTypes.UpdateDamageFlowType({
                  Payload: res.damageFlowType.map(val =>
                    DamageFlowTypeEntityFromBackend(val)
                  )
                })
              : BaseActionTypes.ErrorAction({
                  Payload: { ToasterMessage: ErrorCodes.Load }
                })
          ),
          catchError((err, caught) =>
            of(
              BaseActionTypes.ErrorAction({
                Payload: {
                  ToasterMessage: ErrorCodes.Load,
                  Err: err,
                  Caught: caught
                }
              })
            )
          )
        );
    })
  ));
  constructor(
    private actions$: Actions<DaveActions>,
    private store$: Store<State>,
    private gatewayHttpService: HttpService
  ) {}
}
